

























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { QuestionItemForm, QuestionOptionForm } from "@/serve/question/question";
import { QuestionRuleForm } from "@/serve/question/questionConfig";

interface OptionItem {
  label: string;
  value: string;
}

@Component({
  name: "questionRule"
})
export default class QuestionRule extends Vue {
  @Prop({ default: false }) public visible!: boolean;
  @Prop({ default: () => [] }) public itemList!: QuestionItemForm[];
  @Prop({ default: () => [] }) public ruleList!: QuestionRuleForm[];
  @Prop({ default: false }) public loading!: boolean;
  @Prop({ default: false }) public submitLoading!: boolean;
  @Prop({ default: false }) public ruleDialog!: boolean;
  @Prop({ default: "" }) public ruleDialogTitle!: string;
  @Prop({ required: true }) public ruleForm!: QuestionRuleForm;

  public get innerVisible() { return this.visible; }
  public set innerVisible(value: boolean) { this.$emit("update:visible", value); }
  public get innerRuleDialog() { return this.ruleDialog; }
  public set innerRuleDialog(value: boolean) { this.$emit("update:ruleDialog", value); }
  public get isExternalSource() { return this.ruleForm.sourceType === "external"; }
  public get isItemSource() { return !this.isExternalSource; }
  public get isGenderSource() { return this.isExternalSource && this.ruleForm.sourceField === "gender"; }
  public get isAgeSource() { return this.isExternalSource && this.ruleForm.sourceField === "age"; }
  public get sourceOptions(): QuestionOptionForm[] {
    const item = this.itemList.find(row => row.id === this.ruleForm.itemId);
    return item && item.itemType !== "text" ? item.options || [] : [];
  }
  public get needCompareValue() {
    return ["eq", "ne", "contains", "not_contains", "in", "not_in", "gt", "gte", "lt", "lte", "between"].indexOf(this.ruleForm.conditions) > -1;
  }
  public get targetItemOptions() {
    return this.isItemSource ? this.itemList.filter(item => item.id !== this.ruleForm.itemId) : this.itemList;
  }
  public get conditionsOptions(): OptionItem[] {
    if (this.isGenderSource) {
      return [
        { label: "等于", value: "eq" },
        { label: "不等于", value: "ne" },
        { label: "属于", value: "in" },
        { label: "不属于", value: "not_in" }
      ];
    }
    if (this.isAgeSource) {
      return [
        { label: "等于", value: "eq" },
        { label: "不等于", value: "ne" },
        { label: "大于", value: "gt" },
        { label: "大于等于", value: "gte" },
        { label: "小于", value: "lt" },
        { label: "小于等于", value: "lte" },
        { label: "区间", value: "between" }
      ];
    }
    return [
      { label: "等于", value: "eq" },
      { label: "不等于", value: "ne" },
      { label: "包含", value: "contains" },
      { label: "不包含", value: "not_contains" },
      { label: "为空", value: "empty" },
      { label: "不为空", value: "not_empty" }
    ];
  }
  public get genderValues(): string[] {
    return this.ruleForm.compareValue ? this.ruleForm.compareValue.split(",").filter(Boolean) : [];
  }
  public set genderValues(value: string[]) {
    this.ruleForm.compareValue = (value || []).join(",");
  }
  public submitRule() { this.$emit("submit-rule", this.$refs.ruleForm); }
  public itemLabel(item: QuestionItemForm) { return `${item.itemCode || ""} ${item.itemTitle || ""}`.trim(); }
  public itemLabelById(itemId: number) { const item = this.itemList.find(row => row.id === itemId); return item ? this.itemLabel(item) : ""; }
  public sourceLabel(row: QuestionRuleForm) {
    if (row.sourceType === "external") {
      return `外部：${this.sourceFieldLabel(row.sourceField || "")}`;
    }
    return `内部：${this.itemLabelById(row.itemId as number)}`;
  }
  public compareLabel(row: QuestionRuleForm) {
    if (["empty", "not_empty"].indexOf(row.conditions) > -1) { return "-"; }
    if (row.sourceType === "external") {
      return row.sourceField === "gender" ? this.genderLabel(row.compareValue || "") : row.compareValue || "";
    }
    if (row.optionId) {
      const sourceItem = this.itemList.find(item => item.id === row.itemId);
      const option = sourceItem && (sourceItem.options || []).find(item => item.id === row.optionId);
      return option ? option.optionLabel : row.optionId;
    }
    return row.compareValue || "";
  }
  public sourceFieldLabel(value: string) {
    const map: { [key: string]: string } = { gender: "性别", age: "年龄" };
    return map[value] || value || "";
  }
  public genderLabel(value: string) {
    return (value || "").split(",").map(item => {
      const map: { [key: string]: string } = { male: "男", female: "女", "1": "男", "2": "女", "男": "男", "女": "女" };
      return map[item] || item;
    }).join("、");
  }
  public conditionsLabel(value: string) {
    const map: { [key: string]: string } = {
      eq: "等于",
      ne: "不等于",
      contains: "包含",
      "not_contains": "不包含",
      empty: "为空",
      "not_empty": "不为空",
      in: "属于",
      "not_in": "不属于",
      gt: "大于",
      gte: "大于等于",
      lt: "小于",
      lte: "小于等于",
      between: "区间"
    };
    return map[value] || value || "";
  }
  public actionLabel(value: string) {
    const map: { [key: string]: string } = { show: "显示", hide: "隐藏", required: "设为必填", "not_required": "设为非必填" };
    return map[value] || value || "";
  }
  private ruleRules = {
    sourceType: [{ required: true, message: "请选择条件来源", trigger: "change" }],
    sourceField: [{ required: true, message: "请选择外部条件", trigger: "change" }],
    itemId: [{ required: true, message: "请选择触发题目", trigger: "change" }],
    conditions: [{ required: true, message: "请选择条件", trigger: "change" }],
    targetItemId: [{ required: true, message: "请选择目标题目", trigger: "change" }],
    action: [{ required: true, message: "请选择动作", trigger: "change" }]
  };
}
